var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMulti({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16667 0H11.8333C12.0101 0 12.1797 0.0702379 12.3047 0.195262C12.4298 0.320286 12.5 0.489856 12.5 0.666667V11.3333C12.5 11.5101 12.4298 11.6797 12.3047 11.8047C12.1797 11.9298 12.0101 12 11.8333 12H1.16667C0.989856 12 0.820286 11.9298 0.695262 11.8047C0.570238 11.6797 0.5 11.5101 0.5 11.3333V0.666667C0.5 0.489856 0.570238 0.320286 0.695262 0.195262C0.820286 0.0702379 0.989856 0 1.16667 0ZM5.83533 8.66667L10.5487 3.95267L9.606 3.01L5.83533 6.78133L3.94933 4.89533L3.00667 5.838L5.83533 8.66667Z",
    fill: "#797F86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulti);
export default __webpack_public_path__ + "static/media/multi.aaf27b72c93bea9a36a3db8c2e9409e9.svg";
export { ForwardRef as ReactComponent };